export interface Language {
  language: Array<{
    text: string,
    value: string,
  }>
}

export function getLanguage(): Language {
  return {
    language: [
      { text: 'ไทย', value: 'ไทย' },
      { text: 'อังกฤษ', value: 'อังกฤษ' },
      { text: 'จีน', value: 'จีน' },
      { text: 'ญี่ปุ่น', value: 'ญี่ปุ่น' },
      { text: 'เกาหลี', value: 'เกาหลี' },
      { text: 'รัสเซีย', value: 'รัสเซีย' },
      { text: 'ฝรั่งเศส', value: 'ฝรั่งเศส' },
      { text: 'เยอรมัน', value: 'เยอรมัน' },
    ],
  }
}
